(function () {
  'use strict';

  angular
    .module('iqxCore')
    .controller('ReportParamsCtrl', ReportParamsCtrl)


  function ReportParamsCtrl($scope, $location, $routeParams, FormSvc) {
    // Controller to render a report parameters form from report procedure parameters
    FormSvc.setOptions($scope, {})

    $scope.classes = { label: 'col-sm-4', data: 'col-sm-6' }  // Suitable display proportions

    $scope.reportProc = $routeParams.report
    $scope.queryTitle = $routeParams.title
    $scope.queryButtonCaption = 'Run Report'
    $scope.theParams = []

    $scope.executeQuery = function () {   // Executed by the 'Run Report' button
      $scope.setSubmitted()
      if (!$scope.theForm.$valid) { return }
      var params = ''
      angular.forEach($scope.theParams, function (p) {  // Convert the form parameters into a URL query string
        if (p.value !== undefined) {
          if (params) { params = params + '&' }
          params = params + p.id + '='
          var v
          if (p.type === 'D') {
            v = moment(p.value).format('D/M/YYYY')
          } else if (p.type === 'C') {
            v = (p.value ? '1' : '0')
          } else if (p.type === 'X') {
            v = ''
            angular.forEach(p.value, function (x) {
              if (v) { v = v + String.fromCharCode(9) }  // TAB
              v = v + x
            })
          } else if (p.type === 'U') {
            v = String(p.value).toUpperCase()
          } else {
            v = String(p.value)
          }
          params = params + encodeURIComponent(v)
        }
      })
      if (params) { params = '?' + params }
      $location.url('/report/' + $scope.reportProc + params)  // Go to the report
    }

    let paramDefault = function (tp, val) {  // Get a parameter default value from the metadata in the name
      if (val === '' || tp === 'K' || tp === 'X') { return } // undefined
      if (tp === 'D') {
        switch (val) {
          case '0': return moment().toDate(); // today
          case '0a': return moment().subtract(1, 'days').toDate();  // yesterday
          case '0b': return moment().subtract(1, 'weeks').toDate();  // a week ago
          case '0c': return moment().subtract(1, 'months').toDate(); // a month ago
          case '0d': return moment().subtract(1, 'years').toDate(); // a year ago
          case '1': return moment().startOf('month').toDate();  // start of this month
          case '1a': return moment().subtract(1, 'months').startOf('month').toDate();  // start of last month
          case '31': return moment().endOf('month').toDate();  // end of this month
          case '31a': return moment().subtract(1, 'months').endOf('month').toDate();  // end of last month
          case '101': return moment().startOf('year').toDate();  // start of this year
          case '101a': return moment().subtract(1, 'years').startOf('year').toDate();  // start of last year
          case '3112': return moment().endOf('year').toDate();  // end of this year
          case '3112a': return moment().subtract(1, 'years').endOf('year').toDate();  // end of last year
        }
      } else if (tp === 'M') {
        switch (val) {
          case '0': return moment().month() + 1;  // current month no. (1-12)
          case '0a': return moment().subtract(1, 'months').month() + 1;  // last month no. (1-12)
          default: return val;
        }
      } else if (tp === 'Y') {
        switch (val) {
          case '0': return moment().year();  // current year
          case '0a': return moment().subtract(1, 'years').year();  // last year
          default: return val;
        }
      } else if (tp === 'C') {
        return (val === '1')  // convert to boolean
      } else if (tp === 'I') {
        return parseInt(val)
      } else {
        return val
      }
    }

    let paramGetOptions = function (param, x) {  // Get the options list for a 'select' combo parameter
      $scope.fetch({
        fetchAPI: 'callresult/netreportcombo_' + x,
        fetchTarget: 'reportComboChoices_' + x, multiRow: true
      })
        .then(function () {
          param.options = $scope['reportComboChoices_' + x]
        })
    }

    // Put it together: assemble the form from the route parameters
    var params = $routeParams.params.split(/\,/)
    angular.forEach(params, function (p) {
      var q = { id: p }
      var psplit = p.split(/__/)
      q.label = psplit[0].replace(/_/g, ' ')
      q.type = psplit[1].substr(0, 1).toUpperCase()
      q.required = (q.type === psplit[1].substr(0, 1))  // Uppercase type means required param
      q.value = paramDefault(q.type, psplit[1].substr(1))
      if (q.type === 'K' || q.type === 'X') {
        paramGetOptions(q, psplit[1].substr(1))
      }
      $scope.theParams.push(q)
    })

  }

})()